var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-dependency-injection";
import { RequestClient } from "../basics/request-client.service";
var DashboardClientService = /** @class */ (function () {
    function DashboardClientService(requestClient) {
        this.requestClient = requestClient;
    }
    DashboardClientService.prototype.getDashbardsForUser = function () {
        var request = {};
        return this.requestClient.get("dashboard", request);
    };
    DashboardClientService.prototype.getGlobalDashboards = function () {
        var request = {};
        return this.requestClient.get("dashboard/getglobaldashboards", request);
    };
    DashboardClientService.prototype.getGlobalDashboardsForUser = function () {
        var request = {};
        return this.requestClient.get("dashboard/getglobaldashboardsforuser", request);
    };
    DashboardClientService.prototype.getWidgets = function () {
        var request = {};
        return this.requestClient.get("dashboard/widgets", request);
    };
    DashboardClientService.prototype.persistDashboard = function (dashboard, skipUserAssociation, isGlobalChosen) {
        if (skipUserAssociation === void 0) { skipUserAssociation = false; }
        if (isGlobalChosen === void 0) { isGlobalChosen = false; }
        var request = {
            dashboard: dashboard,
            skipUserAssociation: skipUserAssociation,
            isGlobalChosen: isGlobalChosen
        };
        return this.requestClient.post("dashboard", {}, request);
    };
    DashboardClientService.prototype.persistDashboardMetaData = function (dashboard) {
        var request = {
            dashboard: dashboard,
            skipUserAssociation: false
        };
        return this.requestClient.post("dashboard/SaveDashboardMeta", {}, request);
    };
    DashboardClientService.prototype.persistDashboards = function (dashboards) {
        var request = {
            dashboards: dashboards
        };
        return this.requestClient.post("dashboard/updatedashboards", {}, request);
    };
    DashboardClientService.prototype.deleteDashboard = function (dashboardId) {
        var request = {
            dashboardId: dashboardId
        };
        return this.requestClient.post("dashboard/DeleteDashboard", {}, request);
    };
    DashboardClientService.prototype.deleteUserDashboard = function (dashboardId) {
        var request = {
            dashboardId: dashboardId
        };
        return this.requestClient.post("dashboard/DeleteUserDashboard", {}, request);
    };
    DashboardClientService.prototype.shareDashboard = function (dashboardId, userIds) {
        var request = {
            dashboardId: dashboardId,
            userIds: userIds
        };
        return this.requestClient.post("dashboard/Share", {}, request);
    };
    DashboardClientService = __decorate([
        autoinject,
        __metadata("design:paramtypes", [RequestClient])
    ], DashboardClientService);
    return DashboardClientService;
}());
export { DashboardClientService };
